import type {
  UiAction,
} from '../types';

import * as actionTypes from './actionTypes';

export const setUiState = (
  keyOrRootValues: any,
  maybeValues?: any,
): UiAction => ({
  type: actionTypes.SET_UI_STATE,
  payload: {
    keyOrRootValues,
    maybeValues,
  },
});

export const confirmModal = ({
  modal,
  onError,
  onSuccess,
  onCancel,
  onConfirm,
  onConfirmAction,
  onCancelAction,
}: {
  modal: {
    isOpen?: boolean,
    hideCancel?: boolean,
    title?: string,
    bodyText?: string,
    cancelText?: string,
    confirmText?: string,
  },
  onError?: any,
  onCancel?: any,
  onSuccess?: any,
  onConfirm?: any,
  onCancelAction?: any,
  onConfirmAction?: any,
}) => ({
  type: actionTypes.CONFIRM_MODAL,
  modal,
  onError,
  onSuccess,
  onCancel,
  onConfirm,
  onConfirmAction,
  onCancelAction,
});

export const okConfirmModal = (
  callbacks: any,
  closeModal: any,
) => ({
  type: actionTypes.OK_CONFIRM_MODAL,
  callbacks,
  closeModal,
});

export const cancelConfirmModal = () => ({
  type: actionTypes.CANCEL_CONFIRM_MODAL,
});

export const searchVideoModal = ({
  query,
  scope,
  modal,
  onAssign,
  onCancel,
  onUploaded,
}: {
  query?: string,
  scope?: string,
  modal: {
    title?: string,
    isOpen?: boolean,
    assignedId?: number | string,
    assignedText?: string,
    assignButton?: string,
  },
  onAssign?: any,
  onCancel?: any,
  onUploaded?: any,
}): UiAction => ({
  type: actionTypes.SEARCH_VIDEO_MODAL,
  query,
  scope,
  modal,
  onAssign,
  onCancel,
  onUploaded,
});

export const moveEntityModal = ({
  modal,
  onCancel,
  onSelect,
}: {
  modal: {
    title?: string;
    helper?: string;
    buttonText?: string;
    folderName?: string;
  },
  onCancel?: any,
  onSelect?: any,
}): UiAction => ({
  type: actionTypes.MOVE_ENTITY_MODAL,
  modal,
  onCancel,
  onSelect,
});

export const calcelMoveEntityModal = (): UiAction => ({
  type: actionTypes.CANCEL_MOVE_ENTITY_MODAL,
});

export const selectMoveEntityModal = (values: any, actions: any): UiAction => ({
  type: actionTypes.SELECT_MOVE_ENTITY_MODAL,
  values,
  actions,
});

export const assignSearchVideoModal = (video: any): UiAction => ({
  type: actionTypes.ASSIGN_SEARCH_VIDEO_MODAL,
  video,
});

export const onVideoUploadedSuccess = (video: any): UiAction => ({
  type: actionTypes.ON_UPLOADED_VIDEO_SUCCESS,
  video,
});

export const cancelSearchVideoModal = (): UiAction => ({
  type: actionTypes.CANCEL_SEARCH_VIDEO_MODAL,
});

export const requestUploadVideos = (
  files: Array<File>,
): UiAction => ({
  type: actionTypes.REQUEST_UPLOAD_VIDEOS,
  payload: files,
});

export const requestUploadDocuments = ({
  files,
  folderId,
  documentId,
  callbacks,
}): UiAction => ({
  type: actionTypes.REQUEST_UPLOAD_DOCUMENTS,
  payload: files,
  folderId,
  documentId,
  callbacks,
});

export const cancelUploadFiles = (): UiAction => ({
  type: actionTypes.CANCEL_UPLOAD_FILES,
});

export const setFileUploadState = (payload: any, key: number): UiAction => ({
  type: actionTypes.SET_FILE_UPLOAD_STATE,
  payload,
  meta: {
    key,
  },
});

export const setFileDownloadState = (payload: any, key: number): UiAction => ({
  type: actionTypes.SET_FILE_DOWNLOAD_STATE,
  payload,
  meta: {
    key,
  },
});

export const setBookmarkWorkout = (payload: number): UiAction => ({
  type: actionTypes.SWITCH_BOOKMARK_WORKOUT,
  payload,
});

export const requestSendMessage = ({
  payload,
  conversationId,
  callbacks,
}): UiAction => ({
  type: actionTypes.REQUEST_SEND_MESSAGE,
  payload,
  conversationId,
  callbacks,
});

export const openExercisePicker = ({ onSelect }): UiAction => ({
  type: actionTypes.OPEN_EXERCISE_PICKER,
  onSelect,
});

export const selectExercisePicker = (exerciseId: number): UiAction => ({
  type: actionTypes.SELECT_EXERCISE_PICKER,
  exerciseId,
});

export const cancelExercisePicker = (): UiAction => ({
  type: actionTypes.CANCEL_EXERCISE_PICKER,
});

export const requestDownloadDocument = ({
  documentId,
  documentUrl,
}): UiAction => ({
  type: actionTypes.REQUEST_DOWNLOAD_DOCUMENT,
  documentId,
  documentUrl,
});
